import { Box, HStack } from '@chakra-ui/react'
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js'
import React, { useEffect, useState } from 'react'
import { Line } from 'react-chartjs-2'
import { Pending } from './Pending'
import { Loading } from './Loading'
import { REPOSITORY } from '../../../api/repository/Repository'
import UnderlineHeading from '../../../components/UnderlineText/UnderlineHeading'
import { Quees } from './Quees'
import { Felicitaciones } from './Felicitaciones'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
)

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
      position: 'top',
    },
    title: {
      display: true,
      position: 'top',
      text: 'Últimos 3 meses',
    },
  },
  scales: {
    y: {
      min: 0,
      max: 100,
      ticks: {
        callback: function (value) {
          return value + '%'
        },
      },
    },
  },
}

export default function Indicador() {
  const [pending, setPending] = useState(false)
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState()

  const [showFelicitaciones, setShowFelicitaciones] = useState(false)

  useEffect(() => {
    REPOSITORY.wsEmpresa.dashboard
      .IndicadorDigitalizacion()
      .then((res) => {
        if ([1, 2].includes(res.data.nEscenario)) {
          setPending(true)
        } else {
          setPending(false)
        }

        if (res.data.nEscenario === 4) {
          setShowFelicitaciones(true)
        } else {
          setShowFelicitaciones(false)
        }

        setData(transformData(res.data.lDatos))
      })
      .catch((error) => {
        console.log(error)
        setPending(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  function transformData(lDatos) {
    const monthNames = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ]

    const labels = []
    const data = []

    if (Array.isArray(lDatos) && lDatos.length > 0) {
      lDatos.sort((a, b) => a.YEAR - b.YEAR || a.MONTH - b.MONTH)

      lDatos.forEach((item) => {
        labels.push(monthNames[item.MONTH - 1])
        const value = item.FISICA === 1 ? item.FISICA_PORC : item.DIGITAL_PORC
        data.push(value)
      })
    }

    return {
      labels,
      datasets: [
        {
          data,
          label: 'Value',
          borderColor: '#4FD1C5',
          backgroundColor: 'rgba(79, 209, 197, 0.54)',
        },
      ],
    }
  }

  const renderContent = () => {
    if (loading) {
      return <Loading />
    }

    if (pending || !data) {
      return <Pending />
    }

    return (
      <Box
        w="100%"
        minWidth={593}
        padding="10px"
        borderRadius={15}
        backgroundColor="#fff"
      >
        <Line options={options} data={data} />
      </Box>
    )
  }

  return (
    <>
      <Box alignSelf="flex-start" mb={5}>
        <HStack>
          <UnderlineHeading
            text="Indicador Digitalización Empresa"
            variant="h5"
          />
          <Quees />
        </HStack>
        {showFelicitaciones && <Felicitaciones />}
      </Box>

      {renderContent()}
    </>
  )
}

Indicador.propTypes = {}
